export const GALLERY_OWN_BOX_TITLE = 'gallery.own_box.title';
export const GALLERY_OWN_BOX_ALT_TEXT = 'gallery.own_box.alt_text';
export const GALLERY_OWN_BOX_CLEAR_SELECTED = 'gallery.own_box.clear_selected';
